import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RequestService } from '../../services/request.service';
import { ConfigService } from '../../../core/services/config.service';
import { StorageService } from 'app/core/services/storage.service';

import { of } from 'rxjs/observable/of';


@Injectable()
export class ProfileService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService,
        private storageService: StorageService
    ) {}

    // getProfile(): Observable<any> {
    //     let url = this.configService.get('server').url + this.configService.get('endpoints').ume.profile.details.api;
    //     return this.requestService.get(url);
    // }

    getUserDetailsFromStorage() {
        const oktaTokenStorage = this.storageService.get('okta-token-storage');
        const accessToken = oktaTokenStorage && oktaTokenStorage['accessToken'];
        const claims = accessToken && accessToken['claims'];
        const idToken = accessToken && oktaTokenStorage.idToken;
        let userDetails: any = null
        if (claims) {
            userDetails = {}
            userDetails.id = claims.uid;
            userDetails.domains = [claims.mkpDomain];
            userDetails.name = idToken.claims.name;
            userDetails.username = claims.mkpEmail;
            userDetails.groups = claims.mkpGroups;
        }

        return userDetails
    }

    getProfile(): Observable<any> {
        const userDetails = this.getUserDetailsFromStorage();
        const amberResponseWrapper = {
            data: userDetails,
            flags: {},
            error: null,
            status: null
        }
        return of(amberResponseWrapper)
    }

    editProfile(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').ume.profile.edit.api;
        return this.requestService.post(url, details);
    }

    getNotificationGroups(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').ume.dictionary.notificationGroups.api;
        return this.requestService.get(url);
    };

    getNotificationTypes(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').ume.dictionary.notificationTypes.api;
        return this.requestService.get(url);
    }
    
    getAccountDomain(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.accounts.domain.api;
        return this.requestService.get(url, {}, 'json', true);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/profile/profile.service.ts